/*
 * @format
 *
 * Reducer to capture the last completed commands from the API/device
 *
 */

import * as actionTypes from '../action-types';

/*
const example = {
  'home123': true
};
*/

export const initalState = {};

export default (state = initalState, action) => {
  switch (action.type) {
    case actionTypes.SEND_PRT_STATE_CHANGE: {
      return {
        ...state,
        [action.homeId]: true,
      };
    }

    case actionTypes.NO_SENDS_IN_PROGRESS: {
      return {
        ...state,
        [action.homeId]: false,
      };
    }

    case actionTypes.DEMO_CHANGE_TRACKER: {
      return {
        ...state,
        [action.homeId]: action.waiting,
      };
    }

    case actionTypes.LOGOUT_COMPLETED: {
      return initalState;
    }

    default: {
      return state;
    }
  }
};
